import * as React from 'react';
import { useEffect, useCallback, FC } from 'react';
import { style } from 'typestyle';
import { useStore } from '../../services/store';
import { overlayZIndex } from '../consts';
import { IMedia } from '../../types';
import List from './List';
import Modal from './Modal';
import MobilePlayer from './MobilePlayer';

interface PostViewerProps {
  onPostChange: (post: IMedia | null) => void;
}

const PostViewer: FC<PostViewerProps> = ({ onPostChange }) => {
  const store = useStore();

  // Event handlers
  const handleClose = useCallback(() => {
    store.setStoreState((prevState) => ({ ...prevState, post: null }));
    window.history.replaceState(null, '', null);
  }, [store]);

  // Basic keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') handleClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleClose]);

  if (!store.post) return null;

  // Determine what to show:
  // - On mobile: use MobilePlayer by default
  // - On desktop when product_list mode is enabled: show List component
  // - On mobile when shop_this_look_display is 'modal': show List component
  // - Otherwise: show Modal component
 const showMobilePlayer = store.isMobile && (store.data.settings.mobile_player_display !== false)
  const showProductList = (!showMobilePlayer && store.data.settings.shop_this_look_display === 'product_list') || 
                          (store.isMobile && store.data.settings.shop_this_look_display === 'modal');

  return (
    <div>
      <div className={`${styles.overlay}  ${store.config.classPrefix}-overlay`}
      onClick={handleClose} />
      {showMobilePlayer ? (
        <MobilePlayer
          post={store.post}
          settings={store.data.settings}
          totalPosts={store.data.content.medias.length}
          onClose={handleClose}
          onPostChange={onPostChange}
          classPrefix={store.config.classPrefix || ''}
        />
      ) : showProductList ? (
        <List
          post={store.post}
          settings={store.data.settings}
          totalPosts={store.data.content.medias.length}
          onClose={handleClose}
          onPostChange={onPostChange}
          classPrefix={store.config.classPrefix || ''}
        />
      ) : (
        <Modal
          post={store.post}
          settings={store.data.settings}
          totalPosts={store.data.content.medias.length}
          onClose={handleClose}
          onPostChange={onPostChange}
          classPrefix={store.config.classPrefix || ''}
        />
      )}
    </div>
  );
};

const styles = {
  overlay: style({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: overlayZIndex,
  }),
};

export default PostViewer;
